<template>
    <div class="login-view" :class="configStore.electronMode ? 'white-backgroup' : ''">
        <div class="content">
            <el-form class="form" :model="enterpriseForm" :rules="rules" ref="enterpriseForm"
                @keyup.enter.native="submitEnterprise()" v-loading="loading" element-loading-text="正在提交...">
                <!-- Logo 占位 -->
                <div class="logo">
                    <img src="../assets/image/resized_image.png" alt="logo" class="logo-img" />
                </div>

                <!-- 顶部标题 -->
                <div class="title">
                    <div>欢迎来到{{ appNameZh }}</div>
                </div>

                <!-- 子标题 -->
                <div class="title-content">
                    <div>{{ isChannel ? '输入渠道码' : '输入企业号' }}</div>
                </div>

                <!-- 切换按钮，右上角 -->
                <div class="switch-channel" @click="toChannel">
                    <img src="../assets/image/change.png" alt="logo" class="change-img" />
                    <span style="color: #409eff;font-style: italic;">{{ isChannel ? '切换到企业号' : '切换到渠道码' }}</span>
                </div>

                <!-- 企业号 / 渠道码 输入 -->
                <el-form-item prop="enterpriseNumber" class="form-item-spacing">
                    <el-input v-model="enterpriseForm.enterpriseNumber" autocomplete="off"
                        :placeholder="isChannel ? '渠道码' : '企业号'" clearable maxlength="10" size="medium" />
                </el-form-item>

                <!-- 提交 -->
                <el-button class="submit-btn" type="primary" @click="submitEnterprise()">
                    加入
                </el-button>
            </el-form>
        </div>
        <!-- 底部备案信息 -->
        <!-- <icp></icp> -->
    </div>
</template>
  
<script>
import Icp from '../components/common/Icp.vue'

export default {
    name: 'EnterpriseSelect',
    components: { Icp },
    data() {
        // 自定义校验器
        const validateEnterprise = (rule, value, callback) => {
            const val = value && value.trim()
            if (!val) {
                return callback(new Error('请输入' + (this.isChannel ? '渠道码' : '企业号')))
            }
            if (this.isChannel) {
                if (!/^[A-Za-z0-9]{6}$/.test(val)) {
                    return callback(new Error('渠道码格式错误，请输入 6 位字母或数字'))
                }
            } else {
                if (!/^\d{4,10}$/.test(val)) {
                    return callback(new Error('企业号格式错误，请输入 4-10 位数字'))
                }
            }
            callback()
        }

        return {
            appNameZh: process.env.VUE_APP_ZH_NAME,
            loading: false,
            isChannel: false,
            enterpriseForm: {
                enterpriseNumber: ''
            },
            rules: {
                enterpriseNumber: [
                    { validator: validateEnterprise, trigger: 'blur' }
                ]
            }
        }
    },
    created() {
        localStorage.removeItem('tenantId')
        localStorage.removeItem('channelCode')
    },
    methods: {
        toChannel() {
            this.isChannel = !this.isChannel
            this.enterpriseForm.enterpriseNumber = ''
            // 清除验证信息
            this.$nextTick(() => {
                this.$refs.enterpriseForm.clearValidate('enterpriseNumber');
            });
        },
        submitEnterprise() {
            this.$refs.enterpriseForm.validate(valid => {
                if (!valid) return
                this.loading = true
                const code = this.enterpriseForm.enterpriseNumber.trim()
                const url = this.isChannel
                    ? `/channel/select/${code}`
                    : `/tenant/select/${code}`
                this.$http
                    .get(url)
                    .then(res => {
                        if (res) {
                            localStorage.setItem('tenantId', res.tenantId)
                            localStorage.setItem('channelCode', res.channelCode || '')
                            this.adminConfigStore.loadAdminConfig()
                            this.$router.push({ path: '/login' })
                        } else {
                            this.$message.error(
                                this.isChannel
                                    ? '无效渠道码，请检查后重试'
                                    : '无效企业号，请检查后重试',
                                '提示',
                                { confirmButtonText: '确定' }
                            )
                        }
                    })
                    .finally(() => {
                        this.loading = false
                    })
            })
        }
    }
}
</script>
  
<style scoped lang="scss">
.el-input__inner {
    line-height: 40px !important;
}

.logo-img {
    width: 100%;
    height: 100%;
}

.change-img {
    width: 30px;
    height: 30px;
    margin-right: 5px;
}

.login-view {
    width: 100%;
    height: 100%;
    background: #e8f2ff;
    background-size: cover;
    box-sizing: border-box;
    display: flex;

    &.white-backgroup {
        background: white;
    }

    .content {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;

        .form {
            width: 360px;
            padding: 30px;
            background: white;
            opacity: 0.9;
            box-shadow: 0 0 1px #ccc;
            border-radius: 3%;
            border: 1px solid #ccc;
            overflow: hidden;
            position: relative;

            .logo {
                width: 80px;
                height: 80px;
                background-color: #ccc;
                border-radius: 50%;
                margin: 0 auto;
                margin-bottom: 20px;
                margin-top: 50px;
            }

            .title {
                display: flex;
                justify-content: center;
                align-items: center;
                line-height: 50px;
                margin: 0;
                font-size: 22px;
                font-weight: 600;
                letter-spacing: 2px;
                text-transform: uppercase;
                text-align: center;
            }

            .title-content {
                margin-top: 30px;
                margin-left: 5px;
                margin-bottom: 5px;
                line-height: 30px;
                font-size: 14px;
                font-weight: bold;
            }

            .switch-channel {
                position: absolute;
                top: 20px;
                right: 20px;
                display: flex;
                align-items: center;
                cursor: pointer;
            }

            .icon-placeholder {
                width: 20px;
                height: 20px;
                background-color: #ccc;
                border-radius: 4px;
                margin-right: 5px;
            }

            .form-item-spacing {
                margin-bottom: 50px !important;
                line-height: 50px !important;
            }

            .submit-btn {
                height: 45px;
                border-radius: 10px;
                margin-top: 30px;
                width: 100%;
            }
        }
    }
}
</style>
  